import React, { Fragment } from "react";
import { Card, CardBody, CardHeader, Col,Row } from "reactstrap";
import { H4, H5, P } from "../../../AbstractElements";
import { IMAGE_GALLERY, PortfolioTitle } from "../../../Constant";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";

const ListOfImageDesc = ({ smallImages }) => {
  const description =
    "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.";
  return (
    <Fragment>
      {smallImages.length > 0 && (
        <Col sm="12">
          <Card>
            <CardHeader className="pb-0">
              <H5>{IMAGE_GALLERY}</H5>
            </CardHeader>
            <CardBody>
              <div className="my-gallery gallery-with-description">
                <Row>
                  <Gallery>
                    {smallImages &&
                      smallImages.map((item, i) => {
                        return (
                          <figure className="col-xl-3 col-sm-6" key={i}>
                            <Item
                              original={require(`../../../assets/images/${item}`)}
                              width="1024"
                              height="768"
                              caption="hello"
                            >
                              {({ ref, open }) => (
                                <Link onClick={open}>
                                  <img
                                    className="img-thumbnail"
                                    ref={ref}
                                    src={require(`../../../assets/images/${item}`)}
                                    alt=""
                                  />
                                  <div className="caption">
                                    <H4>{PortfolioTitle}</H4>
                                    <P>{description}</P>
                                  </div>
                                </Link>
                              )}
                            </Item>
                          </figure>
                        );
                      })}
                  </Gallery>
                </Row>
              </div>
            </CardBody>
          </Card>
        </Col>
      )}
    </Fragment>
  );
};
export default ListOfImageDesc;
